import MonthlyIndexContract from './contracts/MonthlyIndexContract.js';
import EthereumQuery from 'decentralized/EthereumQuery.js';
import {web3} from './web3.js';

import {NewMonthlyIndex} from './EthereumEvents.js';
import ipfs from './Ipfs.js';

const contract = new MonthlyIndexContract();

class MonthlyIndexGetter {
    constructor() {
        this.indexContract = new web3.eth.Contract(contract.abi, contract.contractAddress);
        this.indexContractAddress = this.indexContract.options.address;
    }

    async getIndexForMonth(month, year) {
        let indices = await new EthereumQuery(this.indexContractAddress)
            .from(NewMonthlyIndex)
            .select('hash')
            .where('month', month)
            .where('year', year)
            .executeQuery();

        console.log('got the results for monthly = ');
        console.log(indices);

        if (indices === undefined || indices.length === 0) {
            return;
        }

        let hash = indices[0].hash;
        let json = await ipfs.getJson(hash);
        return json;
    }

}

export default MonthlyIndexGetter;
